module.exports = __webpack_public_path__ + "/images/logo-af-mundobebes.f73a29b.png";